import { DetailsChildrenTab, type DetailsPageProps } from 'app/main/components/page-layouts';

import ChronologyListItem from 'app/main/modules/chronology/ChronologyListItem';
import ActivitiesListItem from 'app/main/modules/activities/ActivitiesListItem';
import WorkReportsListItem from 'app/main/modules/workreports/WorkReportsListItem';

import TicketsDetailsTab from './tabs/TicketsDetailsTab';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <TicketsDetailsTab {...props} />
	},
	{
		id: 'chronology',
		title: 'MODULE_CHRONOLOGY_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('chronology') || authorizer.cannot('view', 'chronology'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="chronology"
				content={{ type: 'list', itemLayout: ChronologyListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'chro_tick_uid', filt_clause: 'equals', filt_value: model.tick_uid }]}
			/>
		)
	},
	{
		id: 'activities',
		title: 'MODULE_ACTIVITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('activities') || authorizer.cannot('view', 'activities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="activities"
				content={{ type: 'list', itemLayout: ActivitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'acti_tick_uid', filt_clause: 'equals', filt_value: model.tick_uid }]}
			/>
		)
	},
	{
		id: 'workreports',
		title: 'MODULE_WORKREPORTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('workreports') || authorizer.cannot('view', 'workreports'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="workreports"
				content={{ type: 'list', itemLayout: WorkReportsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'wore_tick_uid', filt_clause: 'equals', filt_value: model.tick_uid }]}
			/>
		)
	}
];

export default tabs;
